import { useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import { useI18n } from '@/lib/i18n'
import {
  tournamentPhaseKeys,
  tournamentUrl,
  useTournamentEdition,
} from './edition'

export function TournamentEntry({
  onSelect,
}: {
  onSelect: (editionId: string) => void
}) {
  const { t } = useI18n()
  const location = useLocation()
  const navigate = useNavigate()
  const { edition, lifecycle } = useTournamentEdition()
  const legacyEdition = new URLSearchParams(location.search).get('tournament')
  useEffect(() => {
    if (legacyEdition)
      navigate(tournamentUrl(legacyEdition), { replace: true })
  }, [legacyEdition, navigate])
  return (
    <div className="space-y-2">
      <button
        type="button"
        role="radio"
        aria-checked={false}
        disabled={!edition}
        data-testid="tournament-entry"
        onClick={() => edition && onSelect(edition.id)}
        className="flex min-h-6 w-full items-start gap-3 text-start text-foreground disabled:opacity-50"
      >
        <span
          className="mt-0.5 flex size-4 shrink-0 rounded-full border border-muted-foreground/50"
          aria-hidden="true"
        />
        <span className="text-sm font-medium leading-5">
          {t('tournament.entry')}
        </span>
        {lifecycle && (
          <span className="ms-auto text-xs text-muted-foreground">
            {t(`tournament.${tournamentPhaseKeys[lifecycle.phase]}`)}
          </span>
        )}
      </button>
      {edition && (
        <Link
          className="inline-flex min-h-11 items-center text-sm underline underline-offset-4"
          to={tournamentUrl(edition.id)}
        >
          {t('tournament.explanation')}
        </Link>
      )}
    </div>
  )
}
